import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solicitud-compra',
  templateUrl: './solicitud-compra.component.html',
  styleUrls: ['./solicitud-compra.component.css']
})
export class SolicitudCompraComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
